export const MIN_TITLE_CHARS = 5;
export const MIN_SUPERVISOR_CHARS = 2;
export const MIN_PAGES = 1;
export const MIN_COPIES = 1;
export const ESTIMATE_DEBOUNCE_MS = 300;

export const URL_PATTERN = /^https?:\/\/[^\s]+$/i;

export const PAYMENT_STEPS: {
  label: string;
  description: string;
}[] = [
  {
    label: "1. You submit",
    description:
      "Fill in the form, attach your manuscript link, and submit. No payment is required at this point.",
  },
  {
    label: "2. Staff format check",
    description:
      "The library reviews formatting, page count, and file. Cost may be adjusted and you will be notified.",
  },
  {
    label: "3. You pay",
    description:
      "Once approved, pay the confirmed amount at the library desk (cash, transfer or POS). Staff record your payment.",
  },
  {
    label: "4. Printing & binding",
    description: "After payment is recorded, printing and binding begin.",
  },
  {
    label: "5. Ready for pickup",
    description: "You will be notified when your copies are ready to collect.",
  },
];
